import React, { useEffect, useState } from 'react';
import './HomeStyles.css';
import {NavLink} from "react-router-dom"

const Home = () => {
  const [patientsTreated, setPatientsTreated] = useState(0);
  const [expertDoctors, setExpertDoctors] = useState(0);
  const [specialties, setSpecialties] = useState(0);
  const [successRate, setSuccessRate] = useState(0);

  useEffect(() => {
    const incrementStats = () => {
      if (patientsTreated < 10000) setPatientsTreated(prev => prev + 100);
      if (expertDoctors < 50) setExpertDoctors(prev => prev + 1);
      if (specialties < 20) setSpecialties(prev => prev + 1);
      if (successRate < 98) setSuccessRate(prev => prev + 1);
    };

    const interval = setInterval(incrementStats, 100); 
    return () => clearInterval(interval);
  }, [patientsTreated, expertDoctors, specialties, successRate]);

  return (
    <main className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Your Health, Our Priority
              </h1>
              <p className="hero-subtitle">
                Experience world-class healthcare with our team of expert physicians and state-of-the-art medical facilities. We're committed to providing compassionate care and exceptional outcomes for every patient.
              </p>
              <div className="hero-cta">
               
                <button className="cta-secondary">
                  <NavLink className='contact' to='/contactus'>Learn More</NavLink>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Our Specialties</h2>
          <p className="section-subtitle">Comprehensive care across medical disciplines Your health deserves specialized attention, and we provide expert care in every field of medicine.</p>
          
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                </svg>
              </div>
              <h3>Cardiac Care</h3>
              <p>Advanced cardiac procedures with world-class outcomes</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                </svg>
              </div>
              <h3>Orthopedic Surgery</h3>
              <p>Restorative procedures for mobility and quality of life</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z"/>
                  <path d="M3 12c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z"/>
                  <path d="M12 21c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z"/>
                  <path d="M12 3c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z"/>
                </svg>
              </div>
              <h3>Neurological Care</h3>
              <p>Specialized treatment for complex neurological conditions</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="16"/>
                  <line x1="8" y1="12" x2="16" y2="12"/>
                </svg>
              </div>
              <h3>General Surgery</h3>
              <p>Comprehensive surgical care with precision and care</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3>Pediatric Care</h3>
              <p>Compassionate healthcare for children</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2v20M12 2L7 7M12 2L17 7"/>
                  <path d="M12 22L7 17M12 22L17 17"/>
                  <path d="M2 12h20M2 12L7 7M2 12L7 17"/>
                  <path d="M22 12L17 7M22 12L17 17"/>
                </svg>
              </div>
              <h3>Oncology</h3>
              <p>Expert cancer treatment and support</p>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">{patientsTreated}+</div>
              <div className="stat-label">Patients Treated</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{expertDoctors}+</div>
              <div className="stat-label">Expert Doctors</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{specialties}+</div>
              <div className="stat-label">Specialties</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{successRate}%</div>
              <div className="stat-label">Success Rate</div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">What Our Patients Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"The care I received was exceptional. The staff was attentive and professional!"</p>
              <h4>- Rajesh varma </h4>
            </div>
            <div className="testimonial-card">
              <p>"I felt safe and well taken care of during my treatment. Highly recommend!"</p>
              <h4>- Dinesh Patel </h4>
            </div>
          </div>
        </div>
        </section>

        
      <section className="doctors-section">
        <div className="container">
          <h2 className="section-title">Meet Our Doctors</h2>
          <div className="doctors-grid">
            <div className="doctor-card">
              <img 
                src='https://i.pinimg.com/736x/60/66/c3/6066c30020ecf3d0a5fcdeabb87ed0e4.jpg' 
                alt="Dr. Shilpa Reddy" 
                className="doctor-image"
              />
              <h3>Dr. Jahnavi</h3>
                            <p>Orthopedic Surgeon</p>

              <div className="doctor-rating">⭐⭐⭐⭐⭐</div>
            </div>
            <div className="doctor-card">
              <img 
                src="https://i.pinimg.com/1200x/46/c2/20/46c22041ea8f59df65001e20c356f37e.jpg" 
                alt="Dr. Priya Nair" 
                className="doctor-image"
              />
              <h3>Dr. Yugendra</h3>
                            <p>Cardiologist</p>

              <div className="doctor-rating">⭐⭐⭐⭐</div>
            </div>
            <div className="doctor-card">
              <img 
                src="https://i.pinimg.com/736x/76/25/38/7625384cac79ea7c582295b3b94274c2.jpg" 
                alt="Dr. Ramesh Iyer" 
                className="doctor-image"
              />
              <h3>Dr. Sandhya</h3>
              <p>General Surgeon</p>
              <div className="doctor-rating">⭐⭐⭐⭐</div>
            </div>

            <div className="doctor-card">
              <img 
                src="https://i.pinimg.com/736x/0c/0c/06/0c0c067d6b4d0c3a6e2fa72849b16c49.jpg" 
                alt="Dr. Lakshmi Menon" 
                className="doctor-image"
              />
              <h3>Dr. Vinay </h3>
              <p>Plastic Surgeon</p>
              <div className="doctor-rating">⭐⭐⭐⭐⭐</div>
            </div>

              <div className="doctor-card">
              <img 
                src="https://i.pinimg.com/1200x/a6/5a/75/a65a75c7910b25ef6d6ee430990be923.jpg" 
                alt="Dr. Lakshmi Menon" 
                className="doctor-image"
              />
              <h3>Dr. Pavithra</h3>
              <p>Facelift Surgery</p>
              <div className="doctor-rating">⭐⭐⭐⭐⭐</div>
            </div>

              <div className="doctor-card">
              <img 
                src="https://i.pinimg.com/736x/ab/c0/0e/abc00ee0111264d8c305f371971291f7.jpg" 
                alt="Dr. Lakshmi Menon" 
                className="doctor-image"
              />
              <h3>Dr. Dinesh </h3>
              <p>Hair PRP Treatment</p>
              <div className="doctor-rating">⭐⭐⭐⭐</div>
            </div>


          </div>
        </div>
      </section>
      
      
      <section className="news-section">
        <div className="container">
          <h2 className="section-title-latest">Latest News</h2>
          <div className="news-grid">
            <div className="news-card">
              <h3>New Cardiac Unit Opening Soon</h3>
              <p>We are excited to announce the opening of our new state-of-the-art cardiac unit.</p>
            </div>
            <div className="news-card">
              <h3>Health Tips for the Summer</h3>
              <p>Stay hydrated and protect your skin this summer with our top health tips.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Begin Your Health Journey?</h2>
            <p className="cta-description">
              Take the first step towards better health with our expert team
            </p>
            <div className="cta-buttons">
              <button className="cta-primary-large">
                <NavLink className='appointment' to='/bookappointment'>Book Appointment</NavLink>
              </button>
              <button className="cta-secondary-large">
                <NavLink className='contact' to='/contactus'>Contact Us</NavLink>
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
